<script setup lang="ts">
import { Page } from "@/components/Ui";
import {
  BlockForPurchases,
  BlockForWork,
  BlockForAffiliate,
  BlockTimezone,
  BlockTimezoneDifference,
  BlockTimezoneCard,
  BlockTimezoneFAQ,
} from "@/components/Blocks";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: t("page.pst.seo.title"),
  description: t("page.pst.seo.description"),
  ogTitle: t("page.pst.seo.title"),
  ogDescription: t("page.pst.seo.description")
});
</script>

<template>
  <div
    :class="$style.root"
    class="container"
  >
    <BlockTimezone />
    <BlockTimezoneDifference />
    <BlockTimezoneCard />
    <div :class="$style.virtual">
      <p :class="[$style.text, $style[`text-${$i18n.locale}`]]">
        {{ $t("cards.forAllNeeds") }}
      </p>
      <Page :class="$style.card">
        <BlockForPurchases />
        <BlockForWork />
        <BlockForAffiliate />
      </Page>
    </div>
    <BlockTimezoneFAQ />
  </div>
</template>

<style lang="scss" module>
.root {
  @apply pt-[17px] pb-[59px] mt-[70px] md:mt-[90px];
}
.text {
  @apply font-bold text-[36px] leading-[100%] text-neutral-800 text-center;
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-de,
  &-it,
  &-pt,
  &-tr,
  &-ua,
  &-es,
  &-fr,
  &-ja,
  &-ru,
  &-bg,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{}
  &-ja {
    @apply leading-[1.2];
  }
}
.virtual {
  @apply mt-[90px] mb-[50px] sm:mb-[70px];
}
.card {
  @apply flex items-center justify-center flex-col lg:flex-row gap-[10px] lg:gap-[40px] mt-[40px];
}
</style>
